<template>
    <div :class="['listener-shell', isNowPlayingRoute ? 'is-now-playing' : '']">
        <div class="listener-shell__bg listener-shell__bg--top"></div>
        <div class="listener-shell__bg listener-shell__bg--bottom"></div>
        <main :class="['listener-shell__content', isNowPlayingRoute ? 'is-now-playing' : '']">
            <keep-alive include="albums,artists,tracks,genres,genre,artist-tracks" max="18">
                <router-view :key="$route.path"></router-view>
            </keep-alive>
        </main>

        <div :class="['listener-shell__dock', isNowPlayingRoute ? 'is-now-playing' : '']">
            <ListenerMiniPlayer v-if="$route.name !== 'playingList'" />
            <nav class="listener-shell__nav">
                <button
                    v-for="item in navItems"
                    :key="item.key"
                    :class="['listener-shell__nav-item', isActive(item) ? 'is-active' : '']"
                    @click="go(item)"
                >
                    <svg v-if="item.key === 'discover'" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 3a9 9 0 1 0 9 9 1 1 0 0 0-2 0 7 7 0 1 1-7-7 1 1 0 0 0 0-2z"></path>
                        <path d="M15.5 8.5a1 1 0 0 0-1.41 0l-3.22 3.22a2.5 2.5 0 1 0 1.41 1.41l3.22-3.22a1 1 0 0 0 0-1.41z"></path>
                    </svg>
                    <svg v-else-if="item.key === 'albums'" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 14.5a4.5 4.5 0 1 1 4.5-4.5A4.5 4.5 0 0 1 12 16.5zm0-7a2.5 2.5 0 1 0 2.5 2.5A2.5 2.5 0 0 0 12 9.5z"></path>
                    </svg>
                    <svg v-else-if="item.key === 'playing'" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M5 5.5A2.5 2.5 0 0 1 7.5 3h9A2.5 2.5 0 0 1 19 5.5v13a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 5 18.5zm5 3.2v6.6a.8.8 0 0 0 1.22.68l5-3.3a.8.8 0 0 0 0-1.36l-5-3.3A.8.8 0 0 0 10 8.7z"></path>
                    </svg>
                    <svg v-else viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 21s-6.72-4.35-9.2-8.3A5.38 5.38 0 0 1 7.35 4.6 5.2 5.2 0 0 1 12 7.09 5.2 5.2 0 0 1 16.65 4.6a5.38 5.38 0 0 1 4.55 8.1C18.72 16.65 12 21 12 21z"></path>
                    </svg>
                    <span>{{ item.label }}</span>
                </button>
            </nav>
        </div>
    </div>
</template>

<script>
import ListenerMiniPlayer from './ListenerMiniPlayer.vue'

export default {
    name: 'ListenerMobileShell',
    components: {
        ListenerMiniPlayer
    },
    computed: {
        isNowPlayingRoute() {
            return this.$route.name === 'playingList'
        }
    },
    data() {
        return {
            navItems: [
                { key: 'discover', label: this.$tt('首页'), route: { path: '/discover' }, match: ['discover'] },
                { key: 'albums', label: this.$tt('专辑'), route: { path: '/albums/recently-added/' }, match: ['albums', 'album'] },
                { key: 'playing', label: this.$tt('播放'), route: { name: 'playing-local' }, match: ['playing', 'playing-local', 'playing-dlna', 'playing-xiaomi', 'playingList', 'queueIndex', 'groupcast'] },
                { key: 'favourites', label: this.$tt('喜爱'), route: { path: '/favourites/albums/' }, match: ['favourites'] }
            ]
        }
    },
    methods: {
        isActive(item) {
            return item.match.indexOf(this.$route.name) !== -1
        },
        go(item) {
            const target = item.route
            if (target.name === this.$route.name || target.path === this.$route.path) {
                return
            }
            this.$router.push(target)
        }
    }
}
</script>

<style scoped>
.listener-shell {
    --listener-shell-mini-player-height: 4.75rem;
    --listener-shell-content-bottom: 11.5rem;
    --listener-shell-dock-height: calc(11.5rem + env(safe-area-inset-bottom, 0px));
    position: relative;
    min-height: 100vh;
    min-height: 100dvh;
    background: linear-gradient(180deg, #f7f6f3 0%, #eef3ff 46%, #f7f7f7 100%);
    overflow: hidden;
}

.listener-shell.is-now-playing {
    height: 100dvh;
    --listener-shell-content-bottom: 0.75rem;
    --listener-shell-dock-height: calc(6.75rem + env(safe-area-inset-bottom, 0px));
}

.listener-shell__bg {
    position: fixed;
    z-index: 0;
    pointer-events: none;
    filter: blur(10px);
}

.listener-shell__bg--top {
    top: -7rem;
    right: -5rem;
    width: 14rem;
    height: 14rem;
    border-radius: 3rem;
    background: radial-gradient(circle, rgba(59, 130, 246, 0.18), rgba(59, 130, 246, 0));
}

.listener-shell__bg--bottom {
    left: -5rem;
    bottom: 5rem;
    width: 13rem;
    height: 13rem;
    border-radius: 999px;
    background: radial-gradient(circle, rgba(244, 114, 182, 0.14), rgba(244, 114, 182, 0));
}

.listener-shell__content {
    position: relative;
    z-index: 1;
    box-sizing: border-box;
    padding: 0.75rem 0.75rem var(--listener-shell-content-bottom);
}

.listener-shell__content.is-now-playing {
    height: calc(100% - var(--listener-shell-dock-height));
    overflow: hidden;
}

.listener-shell__dock {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 20;
    padding: 0 0.75rem calc(env(safe-area-inset-bottom, 0px) + 0.9rem);
    background: linear-gradient(180deg, rgba(247, 246, 243, 0), rgba(247, 246, 243, 0.96) 28%, rgba(247, 246, 243, 1) 100%);
}

.listener-shell__nav {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 0.4rem;
    margin-top: 0.75rem;
    padding: 0.45rem;
    border-radius: 1.45rem;
    background: rgba(255, 255, 255, 0.84);
    backdrop-filter: blur(18px);
    box-shadow: 0 12px 36px rgba(15, 23, 42, 0.08);
}

.listener-shell__nav-item {
    border: 0;
    background: transparent;
    border-radius: 1.1rem;
    padding: 0.55rem 0.3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.28rem;
    color: #64748b;
}

.listener-shell__nav-item svg {
    width: 1.35rem;
    height: 1.35rem;
}

.listener-shell__nav-item span {
    font-size: 0.72rem;
    font-weight: 700;
}

.listener-shell__nav-item.is-active {
    background: #111827;
    color: #fff;
    box-shadow: 0 10px 24px rgba(17, 24, 39, 0.18);
}
</style>
